export interface IEdoSetting {
  key?: string;
  value?: Record<string, any> | null;
}

export const defaultValue: Readonly<IEdoSetting> = {};
